import { hidesWideNameSearchChips, isWideNameSearch, pruneWideNameSearchArms, quantifiedNameMatch } from '~/hooks/wideNameSearch';
// WHY: the actor emits all four name arms together, and ANCR-5557's bundle fold will later remove
// the bundles arm before the filter reaches the store — so three are required and bundles is optional.
const AGREEMENTS_WIDE_NAME_SEARCH = {
    required: [
        'agreementTitle',
        'clientName',
        'services'
    ],
    optional: [
        'bundles'
    ],
    nameMatchOf: (arm, field)=>{
        if (field === 'agreementTitle' || field === 'clientName') return arm[field];
        if (field === 'services' || field === 'bundles') return quantifiedNameMatch(arm[field]);
        return undefined;
    }
};
export const hidesAgreementWideNameSearchChips = (state)=>hidesWideNameSearchChips(AGREEMENTS_WIDE_NAME_SEARCH, state);
export const isAgreementWideNameSearch = (filter)=>isWideNameSearch(AGREEMENTS_WIDE_NAME_SEARCH, filter);
export const pruneAgreementWideNameSearchArms = (filter, orArmMatchCounts)=>pruneWideNameSearchArms(AGREEMENTS_WIDE_NAME_SEARCH, filter, orArmMatchCounts);
